document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector('.slider')!;
  const sliderBody = document.querySelector('.slider .body')!;
  const sliderControls = document.querySelectorAll('.slider .controls a');
  let timer: number;
  function onTimer() {
    if (sliderBody.scrollLeft % sliderBody.clientWidth === 0) {
      sliderBody.scrollTo({
        behavior: 'smooth',
        left: (sliderBody.scrollLeft + sliderBody.clientWidth) % sliderBody.scrollWidth,
      });
    }
  }
  function clearTimer() {
    if (timer) {
      clearInterval(timer);
    }
  }
  function resetTimer() {
    clearTimer();
    timer = setInterval(onTimer, 5000);
  }
  slider.addEventListener('mouseenter', clearTimer);
  slider.addEventListener('mouseleave', resetTimer);
  sliderControls.forEach((control) => {
    control.addEventListener('mousedown', clearTimer);
  });
  sliderBody.addEventListener('scrollend', () => {
    const active = sliderBody.scrollLeft / sliderBody.clientWidth;
    for (let i = 0; i < sliderControls.length; i++) {
      if (active === i) {
        sliderControls[i].classList.add('active');
      } else {
        sliderControls[i].classList.remove('active');
      }
    }
  });
  resetTimer();
});